import { Annotation, AttachmentDetails, EvidenceSessionAIModel } from 'api';
import { Box } from 'ui';

import { AttachmentDetailsDataCard } from '../../../breakdowns/index';
import { AiFilters } from '../../index';

type Props = {
  selectedAnnotation: Annotation[];
  hiddenCategories: string[];
  handleHideCategory: (label: string) => void;
  handleToggleLegend: (checked: boolean) => void;
  showLegend: boolean;
  showSwitch: boolean;
  model: EvidenceSessionAIModel;
  showAerosolAnnotation?: boolean;
  // this is used only to know the label for aerosol
  // if it should be `Aluminium Aerosol` or `Other Aluminium`
  showAerosolBreakdown?: boolean;
  targetWeightPercentage?: number;
  attachmentDetails?: AttachmentDetails;
};

export const AiFiltersAndBreakdownSidebar = ({
  selectedAnnotation,
  hiddenCategories,
  handleHideCategory,
  handleToggleLegend,
  showLegend,
  showSwitch,
  model,
  showAerosolAnnotation,
  targetWeightPercentage,
  attachmentDetails,
  showAerosolBreakdown,
}: Props) => {
  return (
    <Box marginBottom={10}>
      <AiFilters
        selectedAnnotation={selectedAnnotation}
        hiddenCategories={hiddenCategories}
        handleHideCategory={handleHideCategory}
        handleToggleLegend={handleToggleLegend}
        showLegend={showLegend}
        showSwitch={showSwitch}
        model={model}
        showAerosols={showAerosolAnnotation}
      />
      {model === EvidenceSessionAIModel.alu || model === EvidenceSessionAIModel.briquette ? (
        <Box margin={3}>
          <AttachmentDetailsDataCard
            attachmentDetails={attachmentDetails}
            targetWeightPercentage={targetWeightPercentage}
            showAerosol={showAerosolBreakdown}
            isLoading={false}
            aiModel={model}
          />
        </Box>
      ) : null}
    </Box>
  );
};
